import { agendaData } from "../data/agendaData";
import AgendaCard from "../components/AgendaCard";

const Agenda = () => {
  // Get the agenda (index 0 since there's only one item now)
  const agenda = agendaData[0];

  return (
    <section
      className="py-[5rem] md:py-[2rem] xxs:py-[2rem] px-12 bg-brandBlue xs:px-6 xxs:px-6 font-outfit text-white"
      id="agenda"
    >
      <div className="mx-auto text-center">
        <h3 className="text-[1.3125rem] leading-[1.3125rem] mb-[3rem] uppercase tracking-[0.2em] font-normal text-white xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem]">
          Conference Agenda
        </h3>

        <div className="bg-white/5 backdrop-blur rounded-xl p-6 md:p-8 text-left">
          <h3 className="text-xl md:text-2xl font-extrabold mb-4 tracking-wide">
            {agenda.day}
          </h3>

          <div className="space-y-12 xs:space-y-8 xxs:space-y-8">
            {agenda.sessions.map((session, sessionIdx) => (
              <div key={sessionIdx} className="space-y-6">
                <div className="mb-2">
                  <h4 className="text-lg font-bold text-white italic">
                    {session.title}
                  </h4>
                  {session.time && (
                    <p className="text-sm text-white/70">{session.time}</p>
                  )}
                  {session.host && (
                    <p className="text-sm text-white/60">
                      Host: {session.host}
                    </p>
                  )}
                  {session.venue && (
                    <p className="text-sm text-white/60">
                      Venue: {session.venue}
                    </p>
                  )}
                </div>

                <div className="space-y-10">
                  {session.items.map((item, i) => (
                    <AgendaCard
                      key={i}
                      time={item.time}
                      description={item.description}
                      speaker={item.speaker}
                      details={item.details}
                      panelists={item.panelists}
                      moderator={item.moderator}
                      openingSession={item.openingSession}
                      panelTitle={item.panelTitle}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Agenda;
